<form [formGroup]="userForm" nz-form nzLayout="vertical">
  <div nz-row [nzGutter]="[8]">
    <div nz-col [nzXs]="24">
      <nz-form-item class="custom-input-wrapper mb-3">
        <nz-form-label class="label">Old Password</nz-form-label>
        <nz-form-control nzErrorTip="please enter your password !">
          <nz-input-group [nzSuffix]="suffixTemplate" nzPrefixIcon="lock" class="custom-input">
            <input
              nz-input
              formControlName="oldPassword"
              placeholder="Password"
              [type]="oldPasswordVisible ? 'text' : 'password'"
            />
          </nz-input-group>
          <ng-template #suffixTemplate>
            <nz-icon
              class="ant-input-password-icon"
              [nzType]="!oldPasswordVisible ? 'eye-invisible' : 'eye'"
              (click)="toggleOldEye()"
            />
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzXs]="24">
      <div nzAlign="flex-start" nzJustify="space-between" nz-flex [nzGap]="'10px'">
        <nz-form-item class="custom-input-wrapper w-100 mb-3">
          <nz-form-label class="label">New Password</nz-form-label>
          <nz-form-control [nzErrorTip]="passwordPatternTpl">
            <nz-input-group [nzSuffix]="suffixTemplate1" nzPrefixIcon="lock" class="custom-input">
              <input
                nz-input
                formControlName="newPassword"
                placeholder="Confirm Password"
                [type]="newPasswordVisible ? 'text' : 'password'"
              />
            </nz-input-group>
            <ng-template #suffixTemplate1>
              <nz-icon
                class="ant-input-password-icon"
                [nzType]="!newPasswordVisible ? 'eye-invisible' : 'eye'"
                (click)="toggleNewEye()"
              />
            </ng-template>
          </nz-form-control>

          <ng-template #passwordPatternTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please Enter your New Password!
            </ng-container>
            <ng-container *ngIf="control.hasError('pattern')"> Please Enter a Valid New Password! </ng-container>
          </ng-template>
        </nz-form-item>
        <nz-icon
          nzType="info-circle"
          nzTheme="outline"
          nz-tooltip
          nzTooltipPlacement="left"
          nzTooltipOverlayClassName="custom-tooltip"
          nzTooltipTitle="Password must contain at least 10 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character from !@#^()[]"
          style="font-size: 20px; margin-top: 35px"
        />
      </div>
    </div>
    <div nz-col [nzXs]="24">
      <nz-form-item class="custom-input-wrapper mb-3">
        <nz-form-label class="label">Confirm New Password</nz-form-label>
        <nz-form-control [nzErrorTip]="passwordErrorTpl">
          <nz-input-group [nzSuffix]="suffixTemplate2" nzPrefixIcon="lock" class="custom-input">
            <input
              nz-input
              formControlName="confirmNewPassword"
              placeholder="Confirm Password"
              [type]="confirmPasswordVisible ? 'text' : 'password'"
            />
          </nz-input-group>
          <ng-template #suffixTemplate2>
            <nz-icon
              class="ant-input-password-icon"
              [nzType]="!confirmPasswordVisible ? 'eye-invisible' : 'eye'"
              (click)="toggleCnfEye()"
            />
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <ng-template #passwordErrorTpl let-control>
    <ng-container *ngIf="control.hasError('required')"> Confirm password is required </ng-container>
    <ng-container *ngIf="control.hasError('passwordMismatch')">
      Password do not match
    </ng-container>
  </ng-template>
</form>
